// 防抖
export function debounce(func,delay){
    let timer = null;
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            func(args)
        },delay)
    }
}